import { useLocation } from 'react-router-dom';

type UseCouponType = {
  coupon: string | null;
  validCouponParam: string;
};

const useCoupon = (): UseCouponType => {
  const params = new URLSearchParams(useLocation().search);
  const paramCoupon = 'c';
  const coupon = params.get(paramCoupon);

  const validCouponParam = coupon ? `${paramCoupon}=${coupon}` : '';

  return { coupon, validCouponParam };
};

export default useCoupon;
